var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCheckmarkOk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    stroke: "#1B3866",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4 12.1c.4 1.2.6 2.5.6 3.9 0 7.2-5.8 13-13 13C8.8 29 3 23.2 3 16 3 8.8 8.8 3 16 3c2.6 0 5 .8 7.1 2.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A4AC",
    d: "M10.5 13.3l5.3 5.4L26.4 8.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCheckmarkOk);
export default __webpack_public_path__ + "static/media/check-checkmark-ok.c3b69e8ce1b107dcfd9289ed8f738add.svg";
export { ForwardRef as ReactComponent };